import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class CustomerLimits {

  @JsonProperty()
  id:number = -1;
  @JsonProperty()
  owner: string | undefined;
  @JsonProperty()
  customerId:number;
  @JsonProperty()
  customerName: string | undefined;
  @JsonProperty()
  accountCode: string | undefined;
  @JsonProperty()
  exchangeCode: string | undefined;
  @JsonProperty()
  contractCode: string | undefined;
  @JsonProperty()
  contractVersion: string | undefined;
  @JsonProperty()
  positionLimit:number;
  @JsonProperty()
  volumeLimit:number;
  @JsonProperty()
  lossLimit:number;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  source: string | undefined;
  @JsonProperty()
  clearingHouse: string | undefined;

}
